import _ from "lodash";

// types
const CAMERA_ROTATION = "CAMERA_ROTATION";
const SET_CAMERA_Z = "SET_CAMERA_Z";
const INCREMENT_CAMERA_Z = "INCREMENT_CAMERA_Z";
const DECREMENT_CAMERA_Z = "DECREMENT_CAMERA_Z";

// actions
export const setCameraRotation = (rotation) => ({
  type: CAMERA_ROTATION,
  payload: rotation,
});

export const setCameraZ = (z) => ({
  type: SET_CAMERA_Z,
  payload: z,
});

export const incrementCameraZ = () => ({
  type: INCREMENT_CAMERA_Z,
});

export const decrementCameraZ = () => ({
  type: DECREMENT_CAMERA_Z,
});

// reducers
export const cameraRotationReducer = (state = [], action) => {
  switch (action.type) {
    case CAMERA_ROTATION:
      state = action.payload;
      return _.clone(state);
    default:
      return _.clone(state);
  }
};

export const cameraZReducer = (state = 1, action) => {
  switch (action.type) {
    case SET_CAMERA_Z:
      state = action.payload;
      return state;
    case INCREMENT_CAMERA_Z:
      state += state / 1.25;
      return state;
    case DECREMENT_CAMERA_Z:
      state -= state / 2;
      return state;
    default:
      return state;
  }
};
